/**
 * ProposalDetailContainer
 *
 *
 */

import React, { useState, useEffect } from 'react';
import MessageAlert from 'utils';
import { PromotionApi } from 'api';
import moment from 'moment';
import { useParams } from 'react-router-dom';

import ProposalDetailPresenter from './ProposalDetailPresenter';

/**----------------------------------------
 * [Component] 총관리자: 프로모션 상세보기 > 컨테이너
 * ----------------------------------------
 */
const ProposalDetailContainer = ({ defaultShopId, permission }) => {
  /* ===== INITIAL ===== */
  // const { productId } = useParams();
  /* ===== STATE ===== */
  const [currentShop, _setCurrentShop] = useState(defaultShopId ?? null);
  const [loading, setLoading] = useState(false);
  const [promotionList, setPromotionList] = useState([]);

  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /**--------------------
   * 프로모션 상세 조회
   * --------------------
   */
  const handleGetPromotionDetail = async () => {
    setLoading(true);
    try {
      const { status, message, data } = await PromotionApi.getPromotions({
        join_tables: `["promotion_shop", "product_policy"]`,
      });
      if (status !== 200) throw { message };

      setTimeout(() => {
        setPromotionList(data);
        setLoading(false);
      }, 750);
    } catch (e) {
      setLoading(false);
      MessageAlert.error(e.message);
    }
  };

  /* ===== HOOKS ===== */
  useEffect(() => {
    handleGetPromotionDetail();
  }, []);

  /* ===== RENDER ===== */
  return (
    <>
      <ProposalDetailPresenter />
    </>
  );
};

/* DF */
ProposalDetailContainer.defaultProps = {
  defaultShopId: null,
  permission: 'ADMIN',
};
export default ProposalDetailContainer;
